import { createFileRoute } from '@tanstack/react-router';
import { getGetEnvironmentAuthorsQueryOptions } from 'ze-sdk';
import { z } from 'zod';
const SearchParamsSchema = z.object({
    tab: z.enum([
        'configuration',
        'deploymentIntegrations',
        'variables',
        'dependencies',
        'members',
        'logs'
    ]).optional(),
    logType: z.string().optional(),
    author: z.string().optional(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
    logPage: z.number().optional()
});
// Will be lazy loaded from MFE
export const Route = createFileRoute('/org/$organization/$project/app/$application/devops/environment/$environment')({
    validateSearch: (search)=>SearchParamsSchema.parse(search),
    loaderDeps: (param)=>{
        let { search: { tab } } = param;
        return {
            tab
        };
    },
    loader: async (param)=>{
        let { params, context: { queryClient }, deps: { tab } } = param;
        if (tab === 'logs') {
            await queryClient.ensureQueryData(getGetEnvironmentAuthorsQueryOptions(params));
        }
    },
    component: ()=>null
});
